import { render, staticRenderFns } from "./ResourceParameters.vue?vue&type=template&id=56b383c0&"
import script from "./ResourceParameters.vue?vue&type=script&lang=js&"
export * from "./ResourceParameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports